import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket'
import { type IResponseEventConversationCalling } from 'entities/Call/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type CallingContentStore } from 'widgets/ConversationMessages/ui/CallingContent/store/CallingContentStore'

export const useEventConversationCalling = (callingContentStore: CallingContentStore) => {
  const { websocket } = useEntitiesContext()
  const handler = (data: IResponseEventConversationCalling) => {
    callingContentStore.handleConversationCallingEvent(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.ClientConversationCalling, handler), [])
}
